const GrnMaster = {

    "bio_master_id": "Bio Master",
    "batch_no": "Batch No",
    "total_quantity": "Total Quantity",
    "available_quantity": "Available Quantity",
    "type": "Type",
    "farm_id": "Farm",
    "status": "Status",
    "search": "Search",

    "kg": "Kg",
    "liter": "Liter",

    "grnMaster": "GRN Master",

    "error_bio_master_id": "Select Bio Master",
    "error_batch_no": "Enter Batch No",
    "error_total_quantity": "Enter Total Quantity",
    "error_available_quantity": "Enter Available Quantity",
    "error_type": "Select Type",
    "error_farm_id": "Select Farm",
    "error_status": "Select Status",

    "table_bio_master": "BIO MASTER",
    "table_batch_no": "BATCH NO",
    "table_total_quantity": "TOTAL QTY",
    "table_available_quantity": "AVAILABLE QTY",
    "table_type": "TYPE",
    "table_farm": "FARM",
    "table_status": "STATUS",

}

export default GrnMaster;
